/// <reference path='../../interfaces/interfaces.d.ts' />
import functions = require('../../global/functions');

'use strict';


class ProcessExportController {
    public static $inject = [
        '$scope',
        '$state',
        '$uibModal',
        'Orgs',
        'User',
        'Employee',
        'Process',
        'bsLoadingOverlayService',
        'toaster',
        '$q',
        'Upload',
    ];

    public def;
    public form;
    public leaveBalance;
    public leaveUsed;
    public leaveError;
    public org;
    public employee;
    public holidays;
    public org_schema;
    public _path;
    public process = {
        type: '',
        state: '',
        extra: {
            transitions: [{
                transition: 'create',
                data: {
                    employee: ''
                }
            }]
        }
    };

    public expense_process = {
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
    };

    constructor(
        private $scope: any,
        private $state: ng.ui.IStateService,
        private $uibModal: any,
        private Org: IOrgsService,
        private User: IUserService,
        private Employee: IEmpService,
        private Process: IProcessService,
        private bsLoadingOverlayService: IBsLoadingService,
        private toaster: toaster.IToasterService,
        private $q: angular.IQService,
        private Upload: any) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        bsLoadingOverlayService.start({ referenceId: 'loader'});
        // detect the type of request you are making through the sate perams
        this.process.type = $state.params['type'];
        _.assign(this.process.extra.transitions[0].data, $state.params['data']);
        // assign the employee ID to the trasition step
        this.process.extra.transitions[0].data.employee = $state.params['employee_id'] || '';

        Process.getDef(this.process.type).then((def) => {
            this.def = def;
            this.checkLoading();
        });

        this.Org.getOrgFromCache((response) => {
            this.org = response;
            this.Org.loadSchema().then((r) => {
                this.org_schema = r.data;
                this.checkLoading();
            });
        });

        this.Employee.loadEmployee(this.User.getUserId()).then((response) => {
            this.employee = response;
            this.checkLoading();
        });
        

        this.form = ['*'];
        if (this.process.type === 'warning') {
            this.form = ['employee', {'key': 'note', 'placeholder': 'Text Explaining Misdemeanor'}];
        }
    }
    
    private checkLoading(): void {
        if (this.def && this.employee && this.org && this.org_schema) {
            this.bsLoadingOverlayService.stop({ referenceId: 'loader'});
        }
    }

    public hasSuperiorAndPermission(): boolean {
        if (this.User.getCurrentUser().userData.superior === null && this.User.hasPermission('org.change_org')) {
            return false;
        }
        return true;
    }

}

angular.module('beneple.process')
    .controller('ProcessExportController', ProcessExportController);



// WEBPACK FOOTER //
// ./frontend/scripts/process/controllers/process_export.controller.ts